import React from "react";
import cl from "classnames";

export default function Tabs({ tab, changeTab }) {
  return (
    <ul className="lesson_tabs nav nav-tabs" role="tablist">
      <li className="lesson_tab_item" role="presentation">
        <button
          type="button"
          className={cl({ active: tab === "editor" })}
          onClick={() => changeTab("editor")}
        >
          Редактор
        </button>
      </li>
      <li className="lesson_tab_item" role="presentation">
        <button
          type="button"
          className={cl({ active: tab === "view" })}
          onClick={() => changeTab("view")}
        >
          Вывод
        </button>
      </li>
      <li className="lesson_tab_item" role="presentation">
        <button
          type="button"
          className={cl({ active: tab === "test" })}
          onClick={() => changeTab("test")}
        >
          Тесты
        </button>
      </li>
      <li className="lesson_tab_item" role="presentation">
        <button
          type="button"
          className={cl({ active: tab === "solution" })}
          onClick={() => changeTab("solution")}
        >
          Решение
        </button>
      </li>
    </ul>
  );
}
